




































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'

import upload from '@/components/upload.vue'

@Component({
  name: 'FormItem',
  components: {
    upload
  }
})
export default class FormItem extends Vue {
  @Prop({ default: null })
  private item: any

  @Prop({ default: null })
  private index!: number

  private setFont (item: any, attr: string): void {
    if (attr === 'font-weight') {
      this.$set(item.val, 0, item.val[0] === '600' ? '400' : '600')
    }
    if (attr === 'text-decoration') {
      this.$set(item.val, 1, item.val[1] === 'underline' ? 'none' : 'underline')
    }
    if (attr === 'font-style') {
      this.$set(item.val, 2, item.val[2] === 'italic' ? 'inherit' : 'italic')
    }
  }

  private setAlign (item: any, align: any): void {
    this.$set(item.val, 3, align)
  }

  private inputBlur (rule: any, item: any): any {
    const reg = new RegExp(rule.regex)
    if (!item.val.match(reg)) {
      this.$alert(rule.tips, '提示')
      item.val = ''
      return false
    }
  }

  private uploadSuccess (): void {
    this.$message.success('upload Success')
  }
}
